window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of DOM related helper functions.
 *
 * @return {Object} Public methods of o_util.dom.
 */
o_util.dom = (function() {
    "use strict";

    /**
     * Cross-browser getElementsByClassName.
     * Will be removed when IE8 is doomed.
     *
     * @deprecated Use native document.getElementsByClassName instead.
     *
     * @example var result = o_util.dom.getElementsByClassname(document, "myClass");
     *
     * @param {Object} parentElement       Parent container element where to search for occurences.
     * @param {String} className                CSS class selector to search for.
     *
     * @return {Array} Array of DOM Elements.
     */
    function getElementsByClassname(parentElement, className) {
        o_global.debug.warn("o_util.dom.getElementsByClassname is deprecated, use native document.getElementsByClassName instead");
        return parentElement.getElementsByClassName(className);
    }

    /**
     * Does the element have a specific class?
     *
     * @deprecated Use the native element.classList.contains("myClass") function instead!
     *
     * @example
     * if (o_util.dom.hasClass(document, "myClass")) {
     *      // Do whatever the force wants you to do... :)
     * }
     *
     * @param {HTMLElement} element     DOM element to investigate.
     * @param {String} className        CSS class selector withour period.
     *
     * @return {Boolean} I can haz class?
     */
    function hasClass(element, className) {
        o_global.debug.warn("o_util.dom.hasClass is deprecated, use native element.classList.contains instead");

        var classList = "";

        if (element && element.getAttribute("class")) {
            classList = element.getAttribute("class");
        } else if (element && element.className) {
            classList = element.className;
        }

        return (!!classList && !!classList.match) ? !!classList.match(new RegExp("(\\s|^)" + className + "(\\s|$)")) : false;
    }

    /**
     * Checks if an element or one of its parents have a certain class name.
     *
     * @example if (o_util.dom.hasClassInParents(element, "myClass")) { ... }
     *
     * @param {Object} ele          Element
     * @param {String} className    Classname to check for
     *
     * @return {Boolean} true if class was found, false if not.
     */
    function hasClassInParents(ele, className) {
        for (; ele && ele !== document; ele = ele.parentNode) {
            if (ele.classList.contains(className)) {
                return true;
            }
        }

        return false;
    }

    /**
     * Checks if an element or one of its ancestors has a certain class name and returns this ancestor or null.
     *
     * @example var wrapper = o_util.dom.getParentByClassName(element, "myClass");
     *
     * @param {Object} ele          Element
     * @param {String} className    Classname to check for
     *
     * @return {Object|null} Element if class was found, null if not.
     */
    function getParentByClassName(ele, className) {
        for (; ele && ele !== document; ele = ele.parentNode) {
            if (ele.classList.contains(className)) {
                return ele;
            }
        }

        return null;
    }

    /**
     * Add Class to Element.
     *
     * @deprecated Use the native element.classList.add("myClass") function instead!
     *
     * @param {Object} ele      element
     * @param {String} cls      classname
     */
    function addClass(ele, cls) {
        o_global.debug.warn("o_util.dom.addClass is deprecated, use native element.classList.add instead");

        if (!hasClass(ele, cls)) {
            ele.className += " " + cls;
        }
    }

    /**
     * Remove Class from Element.
     *
     * @deprecated Use the native element.classList.remove("myClass") function instead!
     *
     * @param {Object} ele      element
     * @param {String} cls      classname
     */
    function removeClass(ele, cls) {
        o_global.debug.warn("o_util.dom.removeClass is deprecated, use native element.classList.remove instead");
        ele.classList.remove(cls);
    }

    /**
     * Add Class to Element if none is existent, remove if it is there.
     *
     * @deprecated Use the native element.classList.toggle("myClass") function instead!
     *
     * @param {Object} ele      element
     * @param {String} cls      classname
     */
    function toggleClass(ele, cls) {
        o_global.debug.warn("o_util.dom.toggleClass is deprecated, use native element.classList.toggle instead");
        ele.classList.toggle(cls);
    }

    /**
     * Converts a String containing HTML into a DocumentFragment containing DomNodes
     *
     * @param {string} htmlString The String containing HTML
     *
     * @return {DocumentFragment}
     */
    function stringToDocumentFragment(htmlString) {
        var wrapperElement = document.createElement("div"),
            documentFragment = document.createDocumentFragment();

        if (typeof htmlString !== "string") {
            o_global.debug.warn("stringToDocumentFragment should be called with strings containing html only, but was called with " + (typeof htmlString));

            return documentFragment;
        }

        wrapperElement.innerHTML = htmlString.trim();

        while (wrapperElement.hasChildNodes()) {
            documentFragment.appendChild(wrapperElement.firstChild);
        }

        return documentFragment;
    }

    /**
     * Return public API.
     */
    return {
        "getElementsByClassname": getElementsByClassname,
        "hasClass": hasClass,
        "hasClassInParents": hasClassInParents,
        "getParentByClassName": getParentByClassName,
        "addClass": addClass,
        "removeClass": removeClass,
        "toggleClass": toggleClass,
        "stringToDocumentFragment" : stringToDocumentFragment
    };
}());

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.addClass = o_util.dom.addClass;
o_global.helper.getElementsByClassname = o_util.dom.getElementsByClassname;
o_global.helper.hasClass = o_util.dom.hasClass;
o_global.helper.hasClassInParents = o_util.dom.hasClassInParents;
o_global.helper.getParentByClassName = o_util.dom.getParentByClassName;
o_global.helper.removeClass = o_util.dom.removeClass;
o_global.helper.toggleClass = o_util.dom.toggleClass;
o_global.helper.stringToDocumentFragment = o_util.dom.stringToDocumentFragment;
